export const CHECKBOXES_SELECT = "checkboxesSelect";
export const CHECKBOXES_MULTI_SELECT = "checkboxesMultiSelect";
export const RADIOS = "radios";
export const CHECKBOXES = "checkboxes";
export const BOOLEAN = "boolean";
export const FILES = "files";
export const FILE = "file";
export const STRING = "string";
export const HTML = "html";
export const ORAL_INTERVIEW = "oralInterview";
export const EMAIL_WITH_CONSENTS = "emailWithConsents";
export const EMAIL = "email";
export const PASSWORD = "password";
export const THEMES = "themes";
export const TAXONOMIES = "taxonomies";
export const EVENTS = "events";
export const BUDGET_DISPATCHER = "budgetDispatcher";
export const BUDGET_CHAPTER = "budgetChapter";
export const BUDGET = "budget";
export const ADDRESS = "address";
export const SELECT = "select";
export const SORTABLE_LIST = "sortableList";
export const MATRIX = "matrix";
